import React from 'react';

import Link from 'next/link';

import { Button, primaryTheme } from '@repo/ui/components/Buttons';
import { themeStyle } from '@repo/ui/theming';

import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { getMediaCdnUrl } from 'global/prismicUtils';
import { FlexRow } from 'styles/layouts';

import { Wrapper, Description } from './styles';

const getBooleanProp = (slice, key) => {
  if (slice.primary[key] !== null) {
    return slice.primary[key];
  }

  // return defaults
  switch (key) {
    case 'controls':
      return false;
    case 'loop':
      return true;
    case 'muted':
      return true;
    default:
      return false;
  }
};

const VideoSlice = ({ slice }) => {
  const VideoElement = ({ isLink }) => (
    <>
      <VideoPlayer
        autoPlay={getBooleanProp(slice, 'loop')}
        controls={getBooleanProp(slice, 'controls')}
        loop={getBooleanProp(slice, 'loop')}
        muted={getBooleanProp(slice, 'muted')}
        src={getMediaCdnUrl(slice.primary.video?.url)}
        theme={{
          border: slice.primary.border
            ? `8px solid ${themeStyle.varBackgroundAlt}`
            : 'none',
          borderRadius: themeStyle.radiusLarge,
          shadow: 'unset',
          cursor: isLink ? 'pointer' : 'default',
        }}
        youtubeEmbedId={slice.primary.youtubeEmbedId}
      />
      {slice.primary.description && (
        <Description>{slice.primary.description}</Description>
      )}
    </>
  );

  if (!slice.primary.link?.url) {
    return (
      <Wrapper>
        <VideoElement />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Link href={slice.primary.link.url}>
        <VideoElement isLink />
        {!slice.primary.description && !!slice.primary.buttonLabel && (
          <FlexRow justifyContent="center" style={{ marginTop: '18px' }}>
            <Button
              height="40px"
              label={slice.primary.buttonLabel}
              theme={primaryTheme}
              width="auto"
            />
          </FlexRow>
        )}
      </Link>
    </Wrapper>
  );
};

export default VideoSlice;
